export const CALLCENTER_LOGO_WIDTH = 106
